var _path, _path2, _path3, _path4, _rect, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConcatenation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.25C14.0663 2.25 14.1299 2.27634 14.1768 2.32322C14.2237 2.37011 14.25 2.4337 14.25 2.5V8.147C14.25 8.561 14.586 8.897 15 8.897H19.5C19.5663 8.897 19.6299 8.92334 19.6768 8.97022C19.7237 9.01711 19.75 9.0807 19.75 9.147V19C19.75 19.7293 19.4603 20.4288 18.9445 20.9445C18.4288 21.4603 17.7293 21.75 17 21.75H7C6.27065 21.75 5.57118 21.4603 5.05546 20.9445C4.53973 20.4288 4.25 19.7293 4.25 19V5C4.25 4.27065 4.53973 3.57118 5.05546 3.05546C5.57118 2.53973 6.27065 2.25 7 2.25H14Z",
    fill: "#FFB922"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.086 2.63747C15.943 2.52247 15.75 2.63947 15.75 2.82347V7.14647C15.75 7.28447 15.862 7.39647 16 7.39647H19.298C19.416 7.39647 19.49 7.27247 19.422 7.17647L16.408 2.97947C16.3161 2.85189 16.2078 2.73691 16.086 2.63747Z",
    fill: "#FFB922"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 14.25C34.0663 14.25 34.1299 14.2763 34.1768 14.3232C34.2237 14.3701 34.25 14.4337 34.25 14.5V20.147C34.25 20.561 34.586 20.897 35 20.897H39.5C39.5663 20.897 39.6299 20.9233 39.6768 20.9702C39.7237 21.0171 39.75 21.0807 39.75 21.147V31C39.75 31.7293 39.4603 32.4288 38.9445 32.9445C38.4288 33.4603 37.7293 33.75 37 33.75H27C26.2707 33.75 25.5712 33.4603 25.0555 32.9445C24.5397 32.4288 24.25 31.7293 24.25 31V17C24.25 16.2707 24.5397 15.5712 25.0555 15.0555C25.5712 14.5397 26.2707 14.25 27 14.25H34Z",
    fill: "#1AB00A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.086 14.6375C35.943 14.5225 35.75 14.6395 35.75 14.8235V19.1465C35.75 19.2845 35.862 19.3965 36 19.3965H39.298C39.416 19.3965 39.49 19.2725 39.422 19.1765L36.408 14.9795C36.3161 14.8519 36.2078 14.7369 36.086 14.6375Z",
    fill: "#1AB00A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 15,
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.875 19.5H21.5M21.5 19.5H24.125M21.5 19.5V16.875M21.5 19.5V22.125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcatenation);
export default __webpack_public_path__ + "static/media/concatenation.9d8032c06c701351bd49f369b7dcfc9a.svg";
export { ForwardRef as ReactComponent };